import { Dashboard, OffPlanView } from '@/components';

export const OffPlanViewPage = () => (
  <Dashboard openLogIn>
    <OffPlanView />
  </Dashboard>
);
